<template>
	<ProcessCreatePage>
		<Header :title="$t('generate_form_select_ancillary_service_work').toString()">
			<p>
				{{ $t('required_data_red_stars') }}
			</p>
		</Header>

		<div class="main justify-center">
			<div v-if="ancillaryServices">
				<div
					class="bg-gray-300 rounded flex flex-grow p-4 mb-6 justify-center shadow"
					style="align-self: start"
					v-for="ancillaryService in ancillaryServices"
					:key="ancillaryService.id"
				>
					<input
						class="mr-6 w-6 h-6 cursor-pointer"
						:disabled="false"
						type="checkbox"
						style="accent-color: #0068B4;"
						:checked="ancillaryService.value"
						v-model="ancillaryService.value"
						v-bind="$attrs"
					/>
					<div class="w-full flex">
						<span class="font-semibold" :style="{ color: '#2c3e50' }">{{ ancillaryService.label }}</span>
					</div>
				</div>
			</div>
		</div>
		<Footer
			@backButtonClick="$emit('previous', $event)"
			@continueButtonClick="continueButtonClick()"
			@skipButtonClick="continueButtonClick(true)"
			:disable-continue="ancillaryServices == null"
			:is-back-button="false"
			:is-skippable="false"
		/>
	</ProcessCreatePage>
</template>

<script>
import Footer from '@/components/damagecases/Footer';
import Header from '@/components/damagecases/Header';
import RepairShopRepository from '@/api/repositories/RepairShopRepository';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';
import BaseSelect from '@/components/forms/inputs/BaseSelect.vue';
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
import PersonNameForm from '@/components/forms/PersonNameForm.vue';
import AddressInput from '@/components/forms/AddressInput.vue';
import Validate from '@/mixins/Validate';
import CompanyVariablesRepository from '@/api/repositories/CompanyVariablesRepository';

export default {
	name: 'AncillaryServices',
	components: { ProcessCreatePage, Header, Footer },
	mixins: [Validate],
	data() {
		return {
			ancillaryServices: null,
			isLoading: true,
		};
	},
	methods: {
		continueButtonClick: function() {
			if (this.ancillaryServices.filter(element => element.value === true) != null) {
				this.$emit('next', {
					ancillaryServices: this.ancillaryServices,
				});
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
	},
	mounted() {
		this.isLoading = true;
		new CompanyVariablesRepository()
			.getAll()
			.then(response => {
				const filteredCompanyVariables = response.data.data.filter(data => data.key !== 'erstellung_eines_reparaturablaufplans');
				const tempCompanyVariables = [];
				filteredCompanyVariables.forEach(companyVariable => {
					const companyVar = companyVariable;
					companyVar.value = false;
					tempCompanyVariables.push(companyVar);
				});
				this.ancillaryServices = tempCompanyVariables;
				this.isLoading = false;
			})
			.catch(e => {
				console.log(e);
				this.isLoading = false;
			});
	},
};
</script>

<style scoped></style>
